import { render, staticRenderFns } from "./DepartureArrival.vue?vue&type=template&id=12d25138&"
import script from "./DepartureArrival.vue?vue&type=script&lang=ts&"
export * from "./DepartureArrival.vue?vue&type=script&lang=ts&"
import style0 from "./DepartureArrival.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DepartureArrival.vue"
export default component.exports